
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import FooterModal from './FooterModals/FooterModal.vue';
import HeaderModal from './HeaderModals/HeaderModal.vue';

@Component({
  name: 'ModalC6',
  components: { HeaderModal, FooterModal }
})
export default class ModalC6 extends Vue {
  @Prop() switchId!: string;
  @Prop() switchDescription!: string;
  @Prop() eventDescription!: string;
  @Prop() activityDescription!: string;
  @Prop() sendNotification!: boolean;
  @Prop() idModal!: string;
  @Prop({ type: Function }) saveProcess!: any;

  itemToAdd = '';
  itemsList: string[] = [];
  clientsSelected = [];
  clients = ['Vue.js', 'Adonis', 'Rails', 'Sinatra', 'Laravel', 'Phoenix'];
  documentSelected = '';
  documentsTypes = ['Vue.js', 'Javascript', 'Open Source'];
  payConditionSelected = '';
  payConditions = ['Crédito', 'Contado', 'Otro'];
  providerSelected = '';
  providerList = ['Vue.js', 'Javascript', 'Open Source'];
  conceptSelected = '';
  conceptsList = ['Vue.js', 'Javascript', 'Open Source'];

  addItemsList() {
    this.itemsList.push(this.itemToAdd);
    this.itemToAdd = '';
  }
}
